import { Col, Container, Row, Card } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Navbar from '../../components/common/Navbar';
import '../../index.css';
import '../../css/homepage.css';
import { toast } from 'react-toastify';


export default function Home() {

    const navigate = useNavigate();

    const goToForm1 = (formName) => {
        
        if (formName === 'form1') {
            const access = sessionStorage.getItem('form1');
            
            if (access === 'true') {
                navigate('/PreLoadingLogs');
                toast.success('Welcome to Preloading Logs');
            } else {
                toast.error('You don\'t have access to Preloading Form, please contact admin');
            }
        }

    }   
     
    const goToForm2 = (formName) => {

        if (formName === 'form2') {
            const access = sessionStorage.getItem('form2');
            
            if (access === 'true') {
                navigate('/CostSheetEntLogs');
                toast.success('Welcome to CostSheet-Ent Logs');
            } else {
                toast.error('CostSheet-Corp form is in WIP!');
            }
        }


    }   
     
    const goToForm3 = (formName) => {
    
        if (formName === 'form3') {
            const access = sessionStorage.getItem('form3');
            
            if (access === 'true') {
                navigate('/home');
                toast.success('Welcome to CostSheet-Govt Logs');
            } else {
                toast.error('CostSheet-Govt form is in WIP!');
            }
        }

    } 

    const goToForm4 = (formName) => {
        
        if (formName === 'form4') {
            const access = sessionStorage.getItem('form4');
            
            if (access === 'true') {
                navigate('/home');
                toast.success('Welcome to RE-Approval Logs');
            } else {
                toast.error('RE-Approval form is in WIP!');
            }
        }

    };

    return (
        <>
        <Navbar/>
            {/* <h1 className='headerRibbon'>Home</h1> */}
            {/* <h4 className='text-center'>Welcome {userName} San</h4> */}
            <Container fluid className='vh-100' style={{ backgroundColor: "#E0E0E0" }}>
            <Row className="mb-3 pt-5">
                <Col md="6" className="mb-2">
                    <Card className="text-center w-100 h-100 custom-card" bg="light" text="black" onClick={() => goToForm1('form1')}>
                        <Card.Body>
                            <Card.Title>Preloading-Approval</Card.Title>
                        </Card.Body>
                    </Card>
                </Col>
                <Col md="6" className="mb-2">
                <Card className="text-center w-100 h-100 custom-card" bg="light" text="black" onClick={() => goToForm2('form2')}>
                        <Card.Body>
                            <Card.Title>CostSheet Enterprise / Non Tender</Card.Title>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <Row className="pt-5">
                
                <Col md="6" className="mb-2">
                <Card className="text-center w-100 h-100 custom-card" bg="light" text="black" onClick={() => goToForm3('form3')}>
                        <Card.Body>
                            <Card.Title>CostSheet-Govt(WIP)</Card.Title>
                        </Card.Body>
                    </Card>
                </Col>
                <Col md="6" className="mb-2">
                <Card className="text-center w-100 h-100 custom-card" bg="light" text="black" onClick={() => goToForm4('form4')}>
                        <Card.Body>
                            <Card.Title>RE-Approval(WIP)</Card.Title>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>

        </>
    )
}

